import { useParams } from 'react-router';

import { useFormMutation } from 'mutations/useFormMutation';

export function useMutateGeracaoConfigs({ refetch }: { refetch: () => void }) {
    const { mutate: mutateGerar, isLoading: isLoadingGerar } = useFormMutation();
    const { mutate: mutateReverter, isLoading: isLoadingReverter } = useFormMutation();
    const { id } = useParams();

    const gerarConfiguracoes = () => mutateGerar({ url: `/gestao/configpedido/${id}/configautomatica` }, { onSuccess: refetch });

    const reverterConfiguracoes = () => mutateReverter({ url: `/gestao/configpedido/${id}/configautomatica/reverter` }, { onSuccess: refetch });

    return { gerarConfiguracoes, reverterConfiguracoes, isLoadingGerar, isLoadingReverter };
}
